import axios from 'axios';
import toast from 'react-hot-toast';

// Get API URL from environment or use default
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Create axios instance
export const api = axios.create({
  baseURL: `${API_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds
});

// Request interceptor - Add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Network error
    if (!error.response) {
      toast.error('Erro de conexão. Verifique sua internet.');
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    // Handle specific error codes
    switch (status) {
      case 401:
        // Unauthorized - Clear token and redirect to login
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        toast.error('Sessão expirada. Faça login novamente.');
        break;

      case 403:
        toast.error('Você não tem permissão para esta ação.');
        break;

      case 404:
        toast.error('Recurso não encontrado.');
        break;

      case 422:
        // Validation error
        const message = data?.message || 'Dados inválidos.';
        toast.error(Array.isArray(message) ? message[0] : message);
        break;

      case 500:
        toast.error('Erro no servidor. Tente novamente mais tarde.');
        break;

      default:
        const errorMessage = data?.message || 'Erro desconhecido.';
        toast.error(Array.isArray(errorMessage) ? errorMessage[0] : errorMessage);
    }

    return Promise.reject(error);
  }
);

export default api;
